import { post } from 'common/axiosClient';
import { CreateProjectDTO } from '../project.type';
import { API } from 'common/constants/urls';
import { replaceEmptyStringsWithNull } from '../project.util';

// Add this function in project.api.ts
export const createProject = async (project: CreateProjectDTO) => {
  try {
    const processedOtherInfo = replaceEmptyStringsWithNull(project.otherInfo);

    // Update the project object with processed otherInfo
    const updatedProject = { ...project, otherInfo: processedOtherInfo };
    const response = await post(`${API.PROJECT}`, updatedProject);
    return response; // Adjust this based on how your post function works
  } catch (error) {
    console.error('Error creating project:', error);
    throw error;
  }
};
